import DeliverableOneOffCostItemAdminPage from '@pages/admin/deliverableOneOffCostItem.page'
import { createFileRoute } from '@tanstack/react-router'

import { z } from 'zod'

const zSearchParams = z.object({
  selectedKey: z.string().optional(),
  focusedCell: z.string().optional(),
})

export const Route = createFileRoute('/_auth-routes/admin/deliverableOneOffCostItem')({
  component: DeliverableOneOffCostItemAdminPage,
  validateSearch: zSearchParams,
})
